import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import PageLoader from '../../core/loader';
import { publicRoutes } from '../router/router.link';
import ProtectedRoute from './auth/ProtectedRoute';
import { useAuth } from '../../context/AuthContext';

const AppContent = () => {
  const { isAuthenticated, role } = useAuth();
  return (
    <div className="">
      <Suspense fallback={<PageLoader />}>
        {/* <Suspense fallback={<p>Loading...</p>}> */}
        <Routes>
          {/* {publicRoutes.map((route, idx) => (
            <Route key={idx} path={route.path} element={route.element} />
          ))} */}
          {/* <Route path="/" element={<Navigate to="dashboard" replace />} /> */}
          {publicRoutes.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <ProtectedRoute
                  element={route.element}
                  allowedRoles={route.roles}
                  userRole={role}
                  isAuthenticated={isAuthenticated ? true : false}
                />
              }
            />
          ))}
        </Routes>
      </Suspense>
    </div>
  );
};

export default React.memo(AppContent);
